import "./primaryContactDetailsViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import React from "react";
import commonService from "../../../../../shared/services/common.service";

interface PrimaryContactDetailsViewComponentProps {
    facilityPrimaryContactDetails: any
    onEditModeOpen: Function
    canEdit: boolean;
}

const PrimaryContactDetailsViewComponent = (props: PrimaryContactDetailsViewComponentProps) => {
    const {facilityPrimaryContactDetails, onEditModeOpen,canEdit} = props;

    return (
        <div className={'primary-contact-details-view-component details-tab-data-content'}>
            {/*{facilityPrimaryContactDetails && <>*/}
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">Primary Contact Details</div>
                    <div className="">
                        {
                            canEdit &&
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        }
                    </div>
                </div>
                <div className="details-tab-data-body">
                    <Grid container spacing={2} className="pdd-top-0">
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"First Name"}> {facilityPrimaryContactDetails?.firstName || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Last Name"}> {facilityPrimaryContactDetails?.lastName || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Mobile Number"}> {commonService.getMaskedMobileNumber( facilityPrimaryContactDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Fax Number"}> {commonService.getMaskedMobileNumber(facilityPrimaryContactDetails?.faxNumber )|| 'N/A'} </DetailsDataKeyValueComponent>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} xl={6}>
                            <DetailsDataKeyValueComponent
                                title={"Middle Name"}> {facilityPrimaryContactDetails?.middleName || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Email ID"}> {facilityPrimaryContactDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Secondary Mobile Number"}> {facilityPrimaryContactDetails?.secondaryMobileNumber || 'N/A'} </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Account Executive"}> {facilityPrimaryContactDetails?.accountExecutiveDetails?.firstName + " " + facilityPrimaryContactDetails?.accountExecutiveDetails?.lastName} </DetailsDataKeyValueComponent>
                        </Grid>
                    </Grid>
                </div>

            {/*</>}*/}
        </div>
    );

};

export default PrimaryContactDetailsViewComponent;
